import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Theme } from 'src/app/shared/Models/Models';
import { DOCUMENT } from '@angular/common';
import { IviMy26Service } from '../ivi-my26.service';
import { TranslateService } from '@ngx-translate/core';

export interface IviPackageDetails {
  packageTitle: string;
  imageSrc: string,
  features: any[],
  isDisabled: boolean,
  clientPlanId: string,
  isTrialEligible?: boolean; // Indicates if trial is available
  isTrialActive: boolean; // Indicates if the trial is currently active
  isSubscriptionActive?: boolean; // Indicates if the subscription is currently active
  packageDisplayName?: string; // Display name for the package
  featurePageBannerImage?: string; // Image name for the package
  landingPageTileImage?: string; // Background color for the package
  description?: string; // Description for the package
  featureList?: { featureInfo: string; features: { logo: string; heading: string; description: string }[] },
  all_rates?: { rate_per_unit: number; monthly_fee: number; client_rate_schedule_id: string; }[]
}

interface IviClientPlanService {
  client_rate_schedule_id: string;
  rate_per_unit: number;
  monthly_fee: number;
}

interface IviClientPlan {
  parent_plans?: Array<{ client_parent_plan_id?: string }>;
  client_plan_id: string;
  plan_name: string;
  plan_services?: IviClientPlanService[];
}

interface IviSupplementalPlan {
  suppPlanInstanceStatus: string;
}

interface IviMasterPlan {
  clientMasterPlanId: string;
  vinMatch?: boolean;
  suppPlansInfo?: IviSupplementalPlan[];
}

interface IviPlanMergedData {
  all_client_plan_dtls?: IviClientPlan[];
  masterPlansInfo?: IviMasterPlan[];
  eligibilityFlag?: boolean;
  eligibleProducts?: Array<{ productName: string; eligibleMonths: number }>;
}

const selectedPlanHardCoded = [
  {
    packageTitle: 'Package 1',
    //imageSrc: '../../assets/IVI/Trial_Available.jpg',
    imageSrc: '../../assets/IVI/Vector.png',
    features: [],
    isDisabled: true,
    buttonText: 'Subscribed',
    buttonAnnual: 'Annual',
    buttonTrial: 'Trial',
    method: 'showPackageDetails()'
  },
  {
    packageTitle: 'Package 2',
    //  imageSrc: '../../assets/IVI/Subscribtion_Available.jpg',
    imageSrc: 'Honda 360+',
    features: [],
    isDisabled: false,
    buttonText: 'Explore',
    buttonTrial: 'Trial',
    buttonAnnual: 'Annual',
    method: 'showPackageDetails()'
  }
];



@Component({
  selector: 'app-ivi-subscriptions',
  templateUrl: './ivi-subscriptions.component.html',
  styleUrls: ['./ivi-subscriptions.component.scss'],
  standalone: false
})


export class IviSubscriptionsComponent implements OnInit {
  errorCode: string = "000";
  errorFlag: boolean = false;
  isDisabled: boolean = true;
  public selectedPlans: IviPackageDetails[] = [];
  vinExists: boolean = false;
  selectedMP: any;
  selectedSP: any;
  isTrialActive: boolean = false;
  isSubscriptionActive: boolean = false;
  expiryDate: any;
  planStatus: any;
  planDisplayName: any;
  selectedMPArr: any[] = [];
  trialEligiblityFlag: any;
  showSecondPackage: any = 'false';

  packageDetails: {
    packageName?: string;
    planStatus?: string;
    planDisplayName?: string;
    exp?: string;
    isTrialActive?: boolean
    clientPlanId?: string;

  } = {};
  theme: Theme = 'light-theme';
  trialProductNames: { productName: string; eligibleMonths: number }[] = [];
  originalFeaturesList: any;
  pageName: string = 'Subscriptions';

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document,
    private iviService: IviMy26Service, private translate: TranslateService) { }

  ngOnInit() {
    this.errorFlag = false;
    this.translate.use(this.iviService.languageCode).subscribe(() => {
      this.iviService.setTranslatedTitle('Subscriptions'); // added here to set the title for landing page when loading the component first time. Can be removed if we decide to set the title in container component.
    });

    // Check if ADAS package is enabled, then show second package in UI
    if (this.iviService.getPackageKey() === 'true') {
      this.showSecondPackage = this.iviService.getPackageKey();
    }

    this.switchTheme();

    this.iviService.getSubscriptions().subscribe(
      (res) => {
        this.iviService.setPlanMergedData(res); // if not needed then remove
        const vehicleInfo = res?.vehicleInfo || [];
        if (vehicleInfo.length > 0 && vehicleInfo[0]?.TelematicsPlatform === "MY26") {
          const division = vehicleInfo[0].DivisionName; 
          const validDivision = (division === "Honda" || division === "Acura") ? division : "Acura";
          vehicleInfo[0].DivisionName = validDivision;
          this.iviService.setMyVehicleInfoMY26(vehicleInfo[0]);

          if(validDivision === 'Acura')
            this.iviService.setIsAcura(true);

          this.trialProductNames = this.getTrialEligibleProducts();
          this.getAccountContracts();
          this.triggerAmplitudeLogging();
        }
        else {
          this.errorCode = "404";
          this.errorFlag = true;
        }
      },
      (err) => {
        this.errorCode = err.status ?? 500;
        this.errorFlag = true;

        if (err.error.errorMsg == "IVI MY26 Digital Store is not enabled.") {
          this.router.navigateByUrl("/not-found")
        }
      }
    );
  }

  trackByIviPlan(index: number, plan: IviPackageDetails): string | number {
    return plan?.clientPlanId || plan?.packageTitle || index;
  }


  //Returns a detailed list of all plans associated with a client for MY26
  getSubscriptionPlans(): void {
    const planData: IviPlanMergedData = this.iviService.getPlanMergedData() ?? {};
    const planInfo = planData.all_client_plan_dtls ?? [];
    let index = 0;

    planInfo.forEach((iterator: IviClientPlan) => {
      const parentPlans = iterator.parent_plans || [];
      const parentPlanId = parentPlans[0]?.client_parent_plan_id;

      if (parentPlanId === "MY26_Acura_Digital_Service_Subscription_US" ||
        parentPlanId === "MY26_Honda_Digital_Service_Subscription_CAN" ||
        parentPlanId === "MY26_Honda_Digital_Service_Subscription_US" ||
        parentPlanId === "MY26_Acura_Digital_Service_Subscription_CAN") {
        const plan = iterator;

        let planDetails = null;

        if (this.isNotBasicPackage(plan.client_plan_id)) {
          planDetails = this.getPlanDetailInfo(plan.client_plan_id);

          const spPlan: IviPackageDetails = {
            packageTitle: plan.plan_name,
            imageSrc: selectedPlanHardCoded[index]?.imageSrc || '',
            features: selectedPlanHardCoded[index]?.features || [],
            isDisabled: selectedPlanHardCoded[index]?.isDisabled || false,
            clientPlanId: plan.client_plan_id,
            isTrialEligible: planDetails.isTrialEligible,
            isTrialActive: planDetails.isTrialActive,
            isSubscriptionActive: planDetails.isSubscriptionActive,
            packageDisplayName: plan.plan_name,
            description: this.iviService.getPlanAssets(plan.client_plan_id, plan.plan_name).description,
            featureList: this.iviService.getPlanAssets(plan.client_plan_id, plan.plan_name).featureList,
            landingPageTileImage: this.iviService.getPlanAssets(plan.client_plan_id, plan.plan_name).landingPageTileImage,
            featurePageBannerImage: this.iviService.getPlanAssets(plan.client_plan_id, plan.plan_name).featurePageImage,
            all_rates: plan.plan_services
          };

          this.selectedPlans.push(spPlan);
          index++;
        }
      }
    });
  }

  //Method called when Button is clicked in landing page
  showPackageDetails(plan: any): void {
    this.iviService.triggerIVIAmplitudeEventWithProperties({ isAcura: this.iviService.getIsAcura(), eventName: 'Action: Tap Subscription', properties: { 'Page': this.pageName } });
    const planData = this.getPlanDetailInfo(plan.clientPlanId);
    // Prepare package details object
    const obj = {
      packageName: plan.packageTitle,
      clientPlanId: plan.clientPlanId,
      planStatus: planData.isTrialEligible
        ? (planData.isTrialActive ? planData.planStatus || 'NA' : "Trial Available")
        : planData.planStatus || 'Subscription Available',
      exp: planData.expiryDate || 'NA',
      planDisplayName: planData.isTrialEligible
        ? (planData.isTrialActive ? planData.planDisplayName || 'Subscription Available' : "Trial Available")
        : planData.planDisplayName || 'Subscription Available',
      features: selectedPlanHardCoded[0].features,
      isTrialActive: planData.isTrialActive,
      isTrialEligible: planData.isTrialEligible,
      isSubscriptionActive: planData.isSubscriptionActive,
      eligibleMonths: this.trialProductNames?.find(item => item.productName === plan.clientPlanId)?.eligibleMonths || 0,
      packageDisplayName: plan.packageDisplayName,
      description: plan.description,
      featureList: plan.featureList,
      featurePageBannerImage: plan.featurePageBannerImage,
      packageNameImage: plan.packageNameImage,
      annualPrice: this.getFee(plan, "annual", 100),
      monthlyPrice: this.getFee(plan, "monthly", 10),
      trialPrice: this.getFee(plan, "trial", 0)
    };
    this.iviService.setSelectedPkgDetails(obj);
    this.router.navigate(['/ivi/packagedetails']);
  }

  // Method to get fee
  getFee(plan: IviPackageDetails, keyword: string, fallback: number): number {
    return (plan.all_rates ?? []).find(service =>
      service.client_rate_schedule_id.toLowerCase().includes(keyword)
    )?.monthly_fee ?? fallback;
  }

  // Method to get account contracts info 
  getAccountContracts() {
    const acctDetail: IviPlanMergedData = this.iviService.getPlanMergedData() ?? {};
    const masterPlanCount = acctDetail.masterPlansInfo?.length ?? 0;
    if (masterPlanCount > 0) {
      const masterPlansInfo = acctDetail.masterPlansInfo ?? [];
      let selectedMp: IviMasterPlan | undefined;

      // Find the matching master plan
      for (const plan of masterPlansInfo) {
        selectedMp = undefined;
        if (['MY26_Honda_Digital_Service_Subscription_US',
          'MY26_Honda_Digital_Service_Subscription_CAN',
          'MY26_Acura_Digital_Service_Subscription_US',
          'MY26_Acura_Digital_Service_Subscription_CAN'].includes(plan.clientMasterPlanId)) {
          if (plan.vinMatch) {
            selectedMp = plan;
            this.selectedMPArr.push(selectedMp);
            this.vinExists = true;
            // break;
          }
        }

      }

      if (this.vinExists && selectedMp) {
        // Filter and process supplemental plans
        const activePlans = selectedMp.suppPlansInfo?.filter((supPlan: IviSupplementalPlan) =>
          ['Active', 'Terminated', 'Suspended', 'Cancelled', 'Expired'].includes(supPlan.suppPlanInstanceStatus)
        );

        if (activePlans && activePlans.length > 0) {
          this.selectedMP = selectedMp;
        }

        this.getSubscriptionPlans();
      } else {
        this.getSubscriptionPlans(); // Uncomment later if needed
      }
    } else {
      // No master plans available
      this.getSubscriptionPlans();
    }
  }

  switchTheme() {
    this.document.body.classList.replace(
      this.theme, 'dark-theme'
    );
  }

  // Method to extract trial eligible products from the response
  getTrialEligibleProducts(): { productName: string; eligibleMonths: number }[] {
    let responseData = this.iviService.getPlanMergedData();
    this.trialEligiblityFlag = responseData.eligibilityFlag || false;
    let eligibleProducts = responseData.eligibleProducts || []

    if (this.trialEligiblityFlag == true) {
      if (!eligibleProducts || !Array.isArray(eligibleProducts)) {
        return [];
      }

      return eligibleProducts
        .map((product: any) => {
          if (typeof product.productName !== 'string') {
            return '';
          }
          return product.productName.replace(/_Trial/gi, '').trim();
        })
        .map((productName: string, index: number) => ({
          productName,
          eligibleMonths: eligibleProducts[index].eligibleMonths,
        }))
        .filter(item => item.productName); // filter out empty product names
    }
    return [];
  }

  getPlanDetailInfo(clientPlanId: string): any {
    let trialPlan = null;
    let subscriptionPlan = null;

    for (const masterPlan of this.selectedMPArr || []) {
      const suppPlansList = Array.isArray(masterPlan?.suppPlansInfo) ? masterPlan.suppPlansInfo : [];
      for (const suppPlan of suppPlansList) {
        if (suppPlan.clientSuppPlanId !== clientPlanId) continue;
        this.selectedSP = suppPlan;

        const rateSchedule = suppPlan?.clientAltRateScheduleId?.split('_');
        const planName = rateSchedule?.[rateSchedule.length - 2]?.toLowerCase();
        const status = suppPlan.suppPlanInstanceStatus;
        const expiry = suppPlan.nextBillDate;

        if (this.trialEligiblityFlag) {
          const result = this.handleTrialEligible(planName, status, expiry);
          if (result.returnNow) return result.data;
          if (result.trialPlan) trialPlan = result.trialPlan;
          if (result.subscriptionPlan) subscriptionPlan = result.subscriptionPlan;
        } else {
          const result = this.handlePaidSubscription(planName, status, expiry);
          if (result.returnNow) return result.data;
          if (result.trialPlan) trialPlan = result.trialPlan;
          if (result.subscriptionPlan) subscriptionPlan = result.subscriptionPlan;
        }
      }
    }

    if (trialPlan) return trialPlan;
    if (subscriptionPlan) return subscriptionPlan;

    return {
      isTrialActive: false,
      isSubscriptionActive: false,
      isTrialEligible: this.trialEligiblityFlag,
      expiryDate: null,
      planStatus: null,
      planDisplayName: null
    };
  }

  private handleTrialEligible(planName: string, status: string, expiry: any) {
    if (planName === 'trial') {
      if (status === 'Active') {
        return {
          returnNow: true, data: {
            isTrialActive: true,
            isSubscriptionActive: false,
            isTrialEligible: true,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Trial Active"
          }
        };
      } else if (["Terminated", "Suspended", "Cancelled", "Expired"].includes(status)) {
        return {
          trialPlan: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscription Available"
          }
        };
      } else {
        return {
          returnNow: true, data: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: true,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Trial Available"
          }
        };
      }
    } else if (['monthly', 'annual'].includes(planName)) {
      const isActive = status === "Active";
      if (isActive) {
        return {
          returnNow: true, data: {
            isTrialActive: false,
            isSubscriptionActive: true,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscribed"
          }
        };
      } else if (["Terminated", "Suspended", "Cancelled", "Expired"].includes(status)) {
        return {
          subscriptionPlan: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscription Available"
          }
        };
      }
    }
    return {};
  }

  private handlePaidSubscription(planName: string, status: string, expiry: any) {
    if (planName === 'trial') {
      if (status === 'Active') {
        return {
          returnNow: true, data: {
            isTrialActive: true,
            isSubscriptionActive: false,
            isTrialEligible: true,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Trial Active"
          }
        };
      } else if (["Terminated", "Suspended", "Cancelled", "Expired"].includes(status)) {
        return {
          trialPlan: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscription Available"
          }
        };
      } else {
        return {
          trialPlan: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: true,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscription Available"
          }
        };
      }
    } else if (['monthly', 'annual'].includes(planName)) {
      const isActive = status === "Active";
      if (isActive) {
        return {
          returnNow: true, data: {
            isTrialActive: false,
            isSubscriptionActive: true,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscribed"
          }
        };
      } else if (["Terminated", "Suspended", "Cancelled", "Expired"].includes(status)) {
        return {
          subscriptionPlan: {
            isTrialActive: false,
            isSubscriptionActive: false,
            isTrialEligible: false,
            expiryDate: expiry,
            planStatus: status,
            planDisplayName: "Subscription Available"
          }
        };
      }
    }
    return {};
  }

  isNotBasicPackage(planId: string): boolean {
    const basicPackages = [
      'Acura_Basic_Package_US',
      'Acura_Basic_Package_CAN',
      'Honda_Basic_Package_US',
      'Honda_Basic_Package_CAN',
    ];
    return !basicPackages.includes(planId);
  }

  triggerAmplitudeLogging() {
    //below logic is used to set status of the plan in Amplitude logging
    let planStatus = '';
    if (this.selectedPlans && this.selectedPlans.length > 0) {
      const primary = this.selectedPlans[0];
      if (primary.isTrialActive) {
        planStatus = 'Trial Active';
      } else if (primary.isSubscriptionActive) {
        planStatus = 'Subscribed';
      } else if (primary.isTrialEligible) {
        planStatus = 'Trial Available';
      } else {
        planStatus = 'Subscription Available';
      }
    } else {
      planStatus = 'Subscription Available';
    }
    this.iviService.triggerIVIAmplitudeEventWithProperties({ isAcura: this.iviService.getIsAcura(), eventName: 'View: Subscriptions', properties: { 'Page': this.pageName, 'Status': planStatus } });
  }
}
